import { ErrorMessage, Field, Form, Formik } from 'formik';
import '../login/login.scss';
import toastr from '../elements/toast';
import httpApiCall from '../../service/api.service';
import * as Yup from "yup";
import { useState } from 'react';
import Spinner from "react-bootstrap/Spinner";

const ForgotPassword = ({onSubmitSuccess}:any) => {
    const toastrService = new toastr(true);
    const [sppiner, setSppiner] = useState(false);
    const SignupSchema = Yup.object().shape({
        email: Yup.string()
            .email('Invalid email')
            .required('Please enter valid Email'),
    });
    const data = {
        email: ''
    }
    const handleSubmit = (resend: any) => {
        setSppiner(true);
        if (!resend.email || (resend.email && !resend.email.trim())) {
            toastrService.showError('Please enter valid email');
            return;
        }
        const body = {
            partner_email: resend.email.replace(/\s/g, "").toLowerCase()
        }
        httpApiCall({ api: 'forgot_password', type: 'post', body }).then((data) => {
            setSppiner(false);
            if (data.is_error == 0) {
                toastrService.showSuccess('Please check your email for password.');
                onSubmitSuccess(); 
            } else if (data.is_error == 1) {
                toastrService.showError(data.original_text);
            }
        }).catch((error) => {
            console.log("email error");
        })
    }
    return(  <div className='forgot_login'>
        <div className='forgot_login_flows'>
            <div className="flow-right forgot_flow">
                <div className='signUp'>
                    <p className='signUp_up'>Forgot Password? </p>
                    <p className='signUp_portal'>Enter registered email to get reset instructions </p>
                </div>
                <div className='sign_form'>
                    <Formik initialValues={data} onSubmit={handleSubmit} validationSchema={SignupSchema}>
                        <Form>
                            <div className='grouping'>
                                <Field type="email" className='grouping_groups' name="email" placeholder="Email address" autoComplete="email"
/>
                                <small className="text-danger m-2">
                                    <ErrorMessage name="email" />
                                </small>
                            </div>
                            <div>

                                <div className="button_chase">
                                    <button disabled={sppiner} type="submit" className="loginBtn">Submit
                                    {sppiner && <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />}
                                    </button>
                                </div>
                            </div>
                        </Form>

                    </Formik>
                </div>
            </div>
        </div>
    </div>
    ) 
}
export default ForgotPassword;